import dynamic from 'next/dynamic'
import { type NavPopoverContentProps } from '@/features/shared/components/Headers/UngatedHeader/NavPopover/NavPopoverContent'
import { BotOnly } from '@/features/shared/components/BotOnly'
import { ClientOnly } from '@/features/shared/components/ClientOnly'

const NavPopoverContent = dynamic(
  async () => (await import('./NavPopoverContent')).NavPopoverContent,
  { ssr: false },
)

export const NavPopover = (props: NavPopoverContentProps) => (
  <>
    {/* a popover should only be rendered on the client */}
    <ClientOnly>
      <NavPopoverContent {...props} />
    </ClientOnly>
    <BotOnly>
      {!!props.url && <a href={props.url}>{props.title}</a>}
      {props.children({ closeTooltip: () => {} })}
    </BotOnly>
  </>
)
